<template>
	<div class="body">
		<div class="body-container">
			<div class="title"> 一、平台简介</div>

			<div class="content">
				产教大数据综合分析服务平台是聚焦职业教育领域的综合性数据服务平台，以“数据”驱动职业教育教科研及专业建设为核心使命，整合中职、高职专科、职业本科、行业/产业、人才需求等全链条权威数据资源，依托大数据与人工智能技术分析模型，构建区域产业专业（群）适配、岗位能力分析、产教数据分析一体化服务体系，为职业院校提供客观、精准的数据支持与决策参考，助力职业教育高质量发展。
			</div>

			<div class="title">二、联系方式</div>
			<div class="content">
				王先生：13426282778（微信同号）
				肖先生：17723697108（微信同号）
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		name: "About",
		data() {
			return {
				queryParams: {}
			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss">
	@use "mobile.scss";
	@use "about.scss";
</style>